import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.preview = this.element.querySelector("[data-admin-preview-target='card']")
    if (!this.preview) return

    this.handleInput = (event) => this.update(event.target)
    this.element.addEventListener("input", this.handleInput)
    this.element.addEventListener("change", this.handleInput)
    this.element.querySelectorAll("input, select").forEach((field) => this.update(field))
  }

  disconnect() {
    this.element.removeEventListener("input", this.handleInput)
    this.element.removeEventListener("change", this.handleInput)
  }

  update(field) {
    if (!field?.name) return

    if (field.name.endsWith("[background_image]")) {
      this.updateBackground(field)
      return
    }

    if (field.name.endsWith("[title_font]")) {
      if (!field.value) return
      this.preview.querySelector("[data-preview-title]").style.fontFamily = this.fontFamily(field.value)
      return
    }

    if (field.name.endsWith("[card_font]")) {
      if (!field.value) return
      this.preview.querySelector("[data-preview-body]").style.fontFamily = this.fontFamily(field.value)
      return
    }

    if (field.name.endsWith("[title_font_size]")) {
      if (field.value) this.preview.querySelector("[data-preview-title]").style.fontSize = `${field.value}px`
      return
    }

    if (field.name.endsWith("[title_text_transform]")) {
      if (field.value) this.preview.querySelector("[data-preview-title]").style.textTransform = field.value
    }
  }

  updateBackground(field) {
    const file = field.files?.[0]
    if (!file) return
    const reader = new FileReader()
    reader.addEventListener("load", () => {
      this.preview.style.backgroundImage = `url('${reader.result}')`
    })
    reader.readAsDataURL(file)
  }

  fontFamily(value) {
    return {
      cinzel: "Cinzel, serif",
      playfair: "'Playfair Display', serif",
      cormorant: "'Cormorant Garamond', serif",
      great_vibes: "'Great Vibes', cursive",
      tangerine: "Tangerine, cursive",
      dancing_script: "'Dancing Script', cursive",
      alex_brush: "'Alex Brush', cursive",
      caveat: "Caveat, cursive",
      lora: "Lora, serif",
      merriweather: "Merriweather, serif",
      eb_garamond: "'EB Garamond', serif",
    }[value] || "Cinzel, serif"
  }
}
